"use client"

import { ProductCard } from "@/components/product-card"

interface ProductsGridProps {
  products: any[]
  viewMode: "grid" | "list"
}

export function ProductsGrid({ products, viewMode }: ProductsGridProps) {
  const gridClasses = viewMode === "grid" 
    ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 sm:gap-6"
    : "grid grid-cols-1 gap-4 sm:gap-6"

  return (
    <div className={gridClasses}>
      {products.map((product: any) => (
        <ProductCard key={product.id} product={product} viewMode={viewMode} />
      ))}
    </div>
  )
} 